<script>
</script>

<footer>
	<div class="yourfeed">Yourfeed</div>
</footer>

<style>
	footer {
		padding: 55px;
		text-align: center;
	}

	.yourfeed {
		font-size: 14px;
		color: #ddd;
		display: inline-block;
		padding: 21px;
		border-top: 1px solid #ddd;
	}
	@media (max-height: 750px) {
		footer {padding: 4px;}
		.yourfeed {padding: 13px;}
	}
</style>
